export function initCode() {
  if (!window.hljs) {
    return;
  }

  document.querySelectorAll('.nd-code').forEach((code) => {
    const languageModifier = Array.from(code.classList).find((className) => {
      return className.startsWith('--language-');
    });

    if (languageModifier) {
      code.classList.add(languageModifier.slice(2));
    }

    window.hljs.highlightElement(code);
  });
}
